var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"base-raw-data"}},[(_vm.rawDatas.length)?_c('div',{attrs:{"xs12":""}},[_vm._v(_vm._s(_vm.rawDatas[0].rawDataText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }